import { appUrl } from 'utils/wrappers';
import Base from 'app/models/base';
import { showSuccess, showResponseError } from 'utils/messages';

export default Base.extend({
  urlRoot: appUrl('credit_cards'),
  rootKey: 'credit_card',

  charge(amount, user) {
    const url = `${this.url()}/charges`;
    const self = this;
    this.sync('create', this, {
      url,
      attrs: { amount },
      success() {
        showSuccess('Charge created successfully');
        self.trigger('charge');
        user.fetch({ reset: true });
      },
      error(res) {
        showResponseError(res);
      },
    });
  },
});



// WEBPACK FOOTER //
// ./app/models/credit_card.js